import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignLeft = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M2 3L18 3M2 7.33333L13.7701 7.33333M2 11.6667L18 11.6667M2 16L10.5517 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default AlignLeft
